import { Navigate, Route, Routes } from "react-router-dom";

import { PAGES_PATH, useCurrentPage } from "../../hooks/CurrentPage";
import KeepoPagesPage from "../KeepoPages";
import KeepoPageFormPage from "../KeepoPages/PageForm";
import AboutPage from "./pages/About";
import AiBuildPage from "./pages/AiBuild";
import { ButtonPage } from "./pages/Button";
import CatalogPage from "./pages/Catalog";
import ItemCatalogPage from "./pages/Catalog/pages/Item";
import FaqPage from "./pages/Faq";
import ItemFaqPage from "./pages/Faq/pages/Item";
import FloatingWhatsappPage from "./pages/FloatingWhatsapp";
import FormPage from "./pages/Form";
import EmailStoragePage from "./pages/Form/pages/EmailStorage";
import FormFieldPage from "./pages/Form/pages/Field";
import { MailChimpStoragePage } from "./pages/Form/pages/MailChimpStorage";
import WhatsappStoragePage from "./pages/Form/pages/WhatsappStorage";
import HighlightsPage from "./pages/Highlights";
import ItemHighlightPage from "./pages/Highlights/pages/Item";
import LinksPage from "./pages/Links";
import ItemLinkPage from "./pages/Links/pages/Item";
import LocationPage from "./pages/Location";
import { AudioMedia } from "./pages/Media/Audio";
import { ImageMediaPage } from "./pages/Media/Image";
import { VideoMedia } from "./pages/Media/Video";
import PricingPage from "./pages/Pricing";
import ItemPricingPage from "./pages/Pricing/pages/Item";
import PublishPage from "./pages/Publish";
import PublishReadyPage from "./pages/Publish/pages/Ready";
import PublishSuccessPage from "./pages/Publish/pages/Success";
import SectionsPage from "./pages/Sections";
import SocialPage from "./pages/Social";
import StartPage from "./pages/Start";
import StylePage from "./pages/Style";
import TemplatesPage from "./pages/Templates";
import TestimonialsPage from "./pages/Testimonials";
import ItemTestimonialPage from "./pages/Testimonials/pages/Item";
import TitlePage from "./pages/Title";
import WelcomePage from "./pages/Welcome";

const EditorPage = () => {
  const { pageGone } = useCurrentPage();
  // a page deleted in the meantime (e.g. Back after deleting it): back to the pages, never the home in its place
  if (pageGone) {
    return <Navigate to={PAGES_PATH} replace />;
  }

  return (
    <Routes>
      {/* the Keepo's pages: the editor's way in and out (the home is one of them) */}
      <Route path="pages" element={<KeepoPagesPage />} />
      <Route path="pages/edit" element={<KeepoPageFormPage />} />
      <Route path="sections" element={<SectionsPage />} />
      <Route path="/title" element={<TitlePage />} />
      <Route path="start" element={<StartPage />} />
      <Route path="templates" element={<TemplatesPage />} />
      <Route path="ai" element={<AiBuildPage />} />
      <Route path="welcome" element={<WelcomePage />} />
      <Route path="about" element={<AboutPage />} />
      <Route path="button" element={<ButtonPage />} />
      <Route path="form" element={<FormPage />} />
      <Route path="form/field" element={<FormFieldPage />} />
      <Route path="form/storage/email" element={<EmailStoragePage />} />
      <Route path="form/storage/whatsapp" element={<WhatsappStoragePage />} />
      <Route path="form/storage/mailchimp" element={<MailChimpStoragePage />} />
      <Route path="catalog" element={<CatalogPage />} />
      <Route path="catalog/item" element={<ItemCatalogPage />} />
      <Route path="links" element={<LinksPage />} />
      <Route path="links/item" element={<ItemLinkPage />} />
      <Route path="social" element={<SocialPage />} />
      <Route path="media/video" element={<VideoMedia />} />
      <Route path="media/audio" element={<AudioMedia />} />
      <Route path="faq" element={<FaqPage />} />
      <Route path="faq/item" element={<ItemFaqPage />} />
      <Route path="highlights" element={<HighlightsPage />} />
      <Route path="highlights/item" element={<ItemHighlightPage />} />
      <Route path="testimonials" element={<TestimonialsPage />} />
      <Route path="testimonials/item" element={<ItemTestimonialPage />} />
      <Route path="pricing" element={<PricingPage />} />
      <Route path="pricing/item" element={<ItemPricingPage />} />
      <Route path="location" element={<LocationPage />} />
      <Route path="floating-whatsapp" element={<FloatingWhatsappPage />} />
      <Route path="media/image" element={<ImageMediaPage />} />
      {/* The full-screen preview is gone (the side preview shows the Keepo): old links go to the pages */}
      <Route path="preview" element={<Navigate to={PAGES_PATH} replace />} />
      <Route path="style" element={<StylePage />} />
      <Route path="publish" element={<PublishPage />} />
      <Route path="publish/ready" element={<PublishReadyPage />} />
      <Route path="publish/success" element={<PublishSuccessPage />} />
      <Route path="*" element={<Navigate to={PAGES_PATH} />} />
    </Routes>
  );
};

export default EditorPage;
